import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ActsService } from 'src/app/services/acts/acts.service';
import { I_DefaultTypes } from 'src/environments/interface';

@Component({
  selector: 'fury-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent {
  private static isInitialLoad = true;

  public items: I_DefaultTypes[] = [];

  constructor(private router: Router, private actsService: ActsService) {
    /**
     * Edge wrong drawing fix
     * Navigate anywhere and on Promise right back
     */
    if (/Edge/.test(navigator.userAgent)) {
      if (DashboardComponent.isInitialLoad) {
        void this.router.navigate(['/apps/chat']).then(() => {
          void this.router.navigate(['/']);
        });

        DashboardComponent.isInitialLoad = false;
      }
    }

    Object.keys(this.actsService.defaultType).forEach((key) => {
      const defaultType = this.actsService.defaultType[key] as I_DefaultTypes;
      if (defaultType.dashboard_display) {
        this.items.push(defaultType);
      }
    });

    this.items.sort((a, b) => {
      return a.order - b.order;
    });
  }
}
